export default __webpack_public_path__ + "static/media/influencer-2.73120e57.png";